import $ from 'jquery';


class MultiFooter {

	constructor() {
		if ($("#multi-footer").length> 0) {
			this.init();
		}
	}

	init() {

		Vue.component('multi-footer', () => import('../components/MultiFooter.vue'));


			let vm = new Vue({
				el: '#multi-footer',
				data: {
					
				},
				methods: {
				}
			});
			

			console.log(1);
		

	}


}

export default MultiFooter;
